import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { FiChevronDown, FiChevronRight } from "react-icons/fi";
import siteConfig from "../../config/siteConfig";
import classNames from "../common/classNames";

const MegaMenuLink = ({ item, onNavigate }) => (
  <Link to={item.href || "#"} onClick={onNavigate}>
    <span>{item.label}</span>
    {item.description && <small>{item.description}</small>}
  </Link>
);

const MegaMenu = ({
  items = siteConfig.navigation || [],
  className,
  onNavigate,
}) => {
  const [openIndex, setOpenIndex] = useState(null);

  useEffect(() => {
    const closeOnEscape = (event) => {
      if (event.key === "Escape") setOpenIndex(null);
    };
    document.addEventListener("keydown", closeOnEscape);
    return () => document.removeEventListener("keydown", closeOnEscape);
  }, []);

  const closeAndNavigate = () => {
    setOpenIndex(null);
    onNavigate?.();
  };

  return (
    <nav
      className={classNames("mega-menu", className)}
      aria-label="Main navigation"
    >
      <div className="site-container">
        <ul className="mega-menu__list">
          {items.map((item, index) => {
            const groups = item.children || [];
            const hasChildren = groups.length > 0;
            const isOpen = openIndex === index;
            const panelId = `mega-menu-panel-${index}`;

            return (
              <li
                className={classNames(
                  "mega-menu__item",
                  hasChildren && "mega-menu__item--has-children",
                )}
                key={`${item.label}-${item.href}`}
                onMouseEnter={() => hasChildren && setOpenIndex(index)}
                onMouseLeave={() => hasChildren && setOpenIndex(null)}
              >
                {hasChildren ? (
                  <button
                    className="mega-menu__trigger"
                    type="button"
                    aria-expanded={isOpen}
                    aria-controls={panelId}
                    onClick={() => setOpenIndex(isOpen ? null : index)}
                  >
                    <span>{item.label}</span>
                    <FiChevronDown aria-hidden="true" />
                  </button>
                ) : (
                  <MegaMenuLink item={item} onNavigate={closeAndNavigate} />
                )}

                {hasChildren && (
                  <div
                    className="mega-menu__panel"
                    id={panelId}
                    hidden={!isOpen}
                  >
                    <div className="site-container mega-menu__panel-inner">
                      <div className="mega-menu__overview">
                        <p className="mega-menu__eyebrow">Explore</p>
                        <Link
                          className="mega-menu__all-link"
                          to={item.href || "/shop"}
                          onClick={closeAndNavigate}
                        >
                          Shop all {item.label}
                          <FiChevronRight aria-hidden="true" />
                        </Link>
                      </div>
                      <ul className="mega-menu__groups">
                        {groups.map((group) => {
                          const groupChildren = group.children || [];
                          return (
                            <li
                              className="mega-menu__group"
                              key={`${group.label}-${group.href}`}
                            >
                              {groupChildren.length ? (
                                <>
                                  <MegaMenuLink
                                    item={group}
                                    onNavigate={closeAndNavigate}
                                  />
                                  <ul>
                                    {groupChildren.map((child) => (
                                      <li key={`${child.label}-${child.href}`}>
                                        <MegaMenuLink
                                          item={child}
                                          onNavigate={closeAndNavigate}
                                        />
                                      </li>
                                    ))}
                                  </ul>
                                </>
                              ) : (
                                <MegaMenuLink
                                  item={group}
                                  onNavigate={closeAndNavigate}
                                />
                              )}
                            </li>
                          );
                        })}
                      </ul>
                    </div>
                  </div>
                )}
              </li>
            );
          })}
        </ul>
      </div>
    </nav>
  );
};

export default MegaMenu;
